import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import axiosInstance from "../../services/axiosComman";
import { handleKeyDown } from "../../utils/OtherFunctions";
import { CloseIcon } from "../../assets/icons";
import { CancelButton, SubmitButton } from "../../utils/Button";
import { NuInput, NuUpload } from "../../utils/Inputs";

// import Modal from "./modal"

const Toast = Swal.mixin({
  toast: true,
  position: "bottom-end",
  showConfirmButton: false,
  timer: 4000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

export default function CreateOrEdit({
  data,
  visible,
  onClose,
  refreshData,
}) {

  const [isLoading,setIsLoading] = useState(false)
  const [selectedFile, setSelectedFile] = useState(null);
  const [createNew, setCreateNew] = useState({
    name:""
  });
  useEffect(() => {
    setCreateNew({
      name:data?.name
    });
  }, [data]);
 
  function handleImageChange(e) {
    const { files, value } = e.target;
    setSelectedFile(files[0]);
  }


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value,{resetForm}) => {
      setIsLoading(true);

      if (data?.id) {
        data.name = value?.name;
        let reqObjs = new FormData();
        reqObjs.append("standards", selectedFile);
        reqObjs.append("name", value.name);


        axiosInstance
          .put(`/Standards/${data?.id}/`, reqObjs)
          .then((res) => {
            if (res.data) {
              setIsLoading(false);
              onClose();
              refreshData();
              resetForm()
              setSelectedFile(null);
              Toast.fire({
                icon: "success",
                title: res.data.msg || "Standard Updated Successfully",
              });
            } else {
              setIsLoading(false);
              Toast.fire({
                icon: "error",
                title: res.data.msg || "standard Update Unsuccessfully",
              });
            }
          })
          .catch((error) => {
            setIsLoading(false);
            console.log(error);
          });
      } else {
        // value.imagePath = "";
        let reqObjs = new FormData();
        reqObjs.append("standards", selectedFile);
        reqObjs.append("name", value.name);

        axiosInstance
          .post("/Standards/", reqObjs)
          .then((res) => {
            if (res.data) {
              onClose();
              refreshData();
              setSelectedFile(null);

              Toast.fire({
                icon: "success",
                title: res.data.msg || "Standard Created Successfully",
              });
            } else {
              Toast.fire({
                icon: "error",
                title: res.data.msg || "Standard Creation Unsuccessfully",
              });
            }
          })
          .catch((error) => console.log(error));
      }
    },
  });
  if (!visible) return null;
  return (
    <>
      <div
        id="modal"
        // onClick={handleOnClose}
        className="bg-black bg-opacity-30 fixed inset-0 backdrop-blur-sm 
    flex justify-center items-center z-10"
      >
        <div className="bg-white mt-12 p-2 rounded-xl w-4/12">
          <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-sm xl:text-base 2xl:text-lg font-medium">
              {data ? "Edit standard" : "New standard"}
            </h3>
            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={onClose}
            >
              <CloseIcon/>
            </span>
          </div>
          <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
            <div className="">
              <div className="relative px-6 flex flex-wrap justify-between">
                <NuInput
                  formik={formik}
                  name="name"
                  label="Name"
                  width="w-full"
                  placeholder="Name"
                />

                <NuUpload
                  label="Logo"
                  width="w-full"
                  onChange={handleImageChange}
                  accept="image/*"
                 />
              </div>

              <div className="flex items-center justify-end px-6 py-6 rounded-b text-xs 2xl:text-sm">
                <CancelButton onClose={onClose} isLoading={isLoading} />
                <SubmitButton isLoading={isLoading} />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
